var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldLabel, FieldText, FieldWrapper, FlexBox, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { useState } from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import { required } from 'redux-form-validators';
import { twitterActions } from 'components/settings/actions/twitter';
import { updateTwitterAccount } from 'components/settings/api/twitter';
import { QueueSelectField } from 'fable/queueSelect';
import { ToggleBox, ToggleBoxHead } from 'fable/toggleBox';
import { NotificationType, useNotifications } from 'hooks/useNotifications';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
const TwitterDetailsForm = ({ handleSubmit, valid, onCloseModal, twitterData, view, }) => {
    var _a;
    const dispatch = useAppDispatch();
    const notify = useNotifications();
    const [asyncStatus, setAsyncStatus] = useState('succeeded');
    const [tweetsEnabled, setTweetsEnabled] = useState((_a = twitterData === null || twitterData === void 0 ? void 0 : twitterData.tweets_enabled) !== null && _a !== void 0 ? _a : false);
    const handleFormSubmit = (values) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setAsyncStatus('loading');
            yield updateTwitterAccount(twitterData.account_id, {
                alias_name: values.twitterName,
                queue_id: values.queue.id,
                tweets_enabled: tweetsEnabled,
            });
            notify({
                title: view === 'add'
                    ? ' Twitter account successfully connected'
                    : 'Twitter details successfully updated',
                time: 3000,
            }, NotificationType.Success);
            dispatch(twitterActions.readAccounts());
            onCloseModal();
            setAsyncStatus('succeeded');
        }
        catch (_b) {
            notify({ title: 'An error occurred when trying to update Twitter details.' }, NotificationType.Error);
            setAsyncStatus('failed');
        }
    });
    return (_jsxs(Form, Object.assign({ onSubmit: handleSubmit(handleFormSubmit) }, { children: [_jsx(ModalHead, { title: `${view === 'add' ? 'Add' : 'Edit'} Twitter account @${twitterData.screen_name}`, onClose: onCloseModal }), _jsx(ModalBody, { children: _jsxs(FlexBox, Object.assign({ flexDirection: "column", gap: "300" }, { children: [_jsx(Field, { label: "Name", name: "twitterName", component: FieldText, validate: [required()], noAlert: true }), _jsx(FieldWrapper, Object.assign({ label: "Queue for incoming conversations", noAlert: true }, { children: _jsx(Field, { name: "queue", component: QueueSelectField, validate: [required()] }) })), _jsxs(FlexBox, Object.assign({ flexDirection: "column", gap: "200" }, { children: [_jsx(FieldLabel, { children: "Create conversations for" }), _jsx(ToggleBox, { title: "Direct messages", isOpen: true, headComponent: ToggleBoxHead, textProps: { variant: '2' }, input: {
                                        name: 'directMessages',
                                        value: '',
                                    }, helpIcon: {
                                        dark: true,
                                        text: 'Direct messages are the most common type of conversations. A conversation is created when someone sends you a direct message.',
                                    }, disabled: true }), _jsx(ToggleBox, { title: "Mentions", isOpen: tweetsEnabled, headComponent: ToggleBoxHead, textProps: { variant: '2' }, input: {
                                        name: 'mentions',
                                        value: '',
                                    }, helpIcon: {
                                        dark: true,
                                        text: 'Conversations for mentions are created when someone mentions you in a tweet.',
                                    }, onChange: setTweetsEnabled })] }))] })) }), _jsx(ModalFoot, { confirmOnClick: handleSubmit(handleFormSubmit), confirmProps: {
                    disabled: !valid,
                    isLoading: asyncStatus === 'loading',
                    type: 'submit',
                }, cancelOnClick: onCloseModal })] })));
};
export const TwitterDetails = reduxForm({
    form: 'twitterDetails',
    enableReinitialize: true,
})(TwitterDetailsForm);
